/* Yuvrit — clinic (centre) landing pages, Shopify build.
   Ported from public/shared/app.js, with the lead pipeline swapped from the
   Cloudflare Worker to the same Vercel Bigin API the sitewide popup uses.

   Handles three things, depending on what is on the page:
     - the lead modal on a clinic page
     - the consultation-preference form on the thank-you page
     - the priority-call / after-hours blocks on the thank-you page
*/

(function () {
  var YUVRIT = window.YUVRIT_CONFIG || {};

  var BIGIN_ENDPOINT =
    YUVRIT.biginEndpoint || "https://yuvrit-bigin-api.vercel.app/api/bigin";
  var SHEET_ENDPOINT = YUVRIT.sheetEndpoint || "";
  var FORM_NAME = YUVRIT.formName || "Clinic_LandingPage1";
  var BRANCH = YUVRIT.branch || "";
  var CENTRE_NAME = YUVRIT.centreName || "";
  var CAMPAIGN = YUVRIT.campaign || "clinic-centre";
  var THANK_YOU_URL = YUVRIT.thankYouUrl || "/pages/clinic-thank-you";

  // Grace period (ms) so GTM-fired conversion tags can send before we navigate.
  var REDIRECT_DELAY_MS = 600;

  var CONSULTATIONS = {
    online: { label: "Online - Video Conferencing", branch: "Online Video Consultation", phone: "" },
    indiranagar: { label: "Indira Nagar", branch: "Indiranagar", phone: "8050787373" },
    hsr: { label: "HSR Layout", branch: "HSR Layout", phone: "8050787854" },
    aecs: { label: "Whitefield (AECS)", branch: "Whitefield (AECS)", phone: "8050787676" },
  };

  // Concern dropdown value → the value Bigin's "Interested in" picklist accepts.
  // These strings must already exist in that picklist (they match the sitewide
  // popup's options). CONCERN_LABELS keeps the visitor's exact wording, which
  // goes into Web_Notes so nothing is lost by the mapping.
  var CONCERN_TO_BIGIN = {
    gut: "Gut health",
    fertility: "Fertility support",
    pain: "Pain management",
    womens: "Women's health",
    wellness: "Wellness & detox",
    panchakarma: "Wellness & detox",
    others: "Other concerns",
  };

  var CONCERN_LABELS = {
    gut: "Gut Health",
    fertility: "Fertility",
    pain: "Knee / Body Pain",
    womens: "Women's Health",
    wellness: "General Wellness",
    panchakarma: "Panchakarma Detox",
    others: "Others",
  };

  /* ==========================================================
     TRACKING — same collection logic as the sitewide popup
     ========================================================== */

  var trackingData = {};
  var pageURL = window.location.href;

  function getUrlParam(param) {
    return new URLSearchParams(window.location.search).get(param) || "";
  }

  function getDeviceType() {
    var ua = navigator.userAgent.toLowerCase();
    if (/mobile|android|iphone|ipod|windows phone/.test(ua)) return "Mobile";
    if (/tablet|ipad|android/.test(ua)) return "Tablet";
    return "Desktop";
  }

  function getBrowserInfo(ua) {
    if (ua.includes("Edge")) return "Edge";
    if (ua.includes("OPR") || ua.includes("Opera")) return "Opera";
    if (ua.includes("Chrome")) return "Chrome";
    if (ua.includes("Safari")) return "Safari";
    if (ua.includes("Firefox")) return "Firefox";
    return "Other";
  }

  function getOSInfo(ua) {
    if (ua.includes("Windows")) return "Windows";
    if (ua.includes("Android")) return "Android";
    if (ua.includes("iPhone") || ua.includes("iPad") || ua.includes("iOS")) return "iOS";
    if (ua.includes("Mac")) return "macOS";
    if (ua.includes("Linux")) return "Linux";
    return "Unknown";
  }

  function getGAClientId() {
    if (window.gtag) return localStorage.getItem("_ga") || "Not Available";
    return "GA4 Not Found";
  }

  function classifyTrafficSource(referrer, utmSource) {
    if (utmSource) return "UTM: " + utmSource;
    if (!referrer || referrer === "Direct") return "Direct";
    if (referrer.includes("google")) return "Organic Search (Google)";
    if (referrer.includes("facebook")) return "Social (Facebook)";
    if (referrer.includes("instagram")) return "Social (Instagram)";
    if (referrer.includes("twitter")) return "Social (Twitter)";
    if (referrer.includes("linkedin")) return "Social (LinkedIn)";
    try {
      return "Referral: " + new URL(referrer).hostname;
    } catch (err) {
      return "Referral";
    }
  }

  function collectTracking() {
    var ua = navigator.userAgent;

    trackingData.formName = FORM_NAME;
    trackingData.pageUrl = pageURL;
    trackingData.pageTitle = document.title;
    trackingData.referrer = document.referrer || "Direct";

    trackingData.utmSource = getUrlParam("utm_source");
    trackingData.utmMedium = getUrlParam("utm_medium");
    trackingData.utmCampaign = getUrlParam("utm_campaign");
    trackingData.utmContent = getUrlParam("utm_content");
    trackingData.utmTerm = getUrlParam("utm_term");
    trackingData.gclid = getUrlParam("gclid");
    trackingData.fbclid = getUrlParam("fbclid");

    trackingData.userAgent = ua;
    trackingData.deviceType = getDeviceType();
    trackingData.browser = getBrowserInfo(ua);
    trackingData.operatingSystem = getOSInfo(ua);
    trackingData.screenResolution = window.screen.width + "x" + window.screen.height;
    trackingData.viewportSize = window.innerWidth + "x" + window.innerHeight;
    trackingData.language = navigator.language || "unknown";
    trackingData.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    trackingData.sessionStartTime =
      sessionStorage.getItem("sessionStart") || new Date().toISOString();
    if (!sessionStorage.getItem("sessionStart")) {
      sessionStorage.setItem("sessionStart", trackingData.sessionStartTime);
    }
    trackingData.formOpenedTime = new Date().toISOString();

    trackingData.gaClientId = getGAClientId();
    trackingData.gtmContainerId = window.gtag ? "GTM Available" : "GTM Not Found";

    trackingData.trafficSource = classifyTrafficSource(
      trackingData.referrer,
      trackingData.utmSource
    );
    trackingData.landingPage = sessionStorage.getItem("landingPage") || pageURL;
    if (!sessionStorage.getItem("landingPage")) {
      sessionStorage.setItem("landingPage", pageURL);
    }

    trackingData.ipAddress = "N/A";
    trackingData.country = "N/A";
    trackingData.city = "";
    fetch("https://ipapi.co/json/")
      .then(function (r) { return r.json(); })
      .then(function (d) {
        trackingData.ipAddress = d.ip;
        trackingData.country = d.country_name || "N/A";
        trackingData.region = d.region || "N/A";
        trackingData.city = d.city || "N/A";
        trackingData.latitude = d.latitude || "N/A";
        trackingData.longitude = d.longitude || "N/A";
        trackingData.isp = d.org || "N/A";
        trackingData.timezone_location = d.timezone || "N/A";
      })
      .catch(function (err) {
        console.warn("Could not fetch IP location:", err);
      });
  }

  /* ==========================================================
     MODAL
     ========================================================== */

  function openModal() {
    var modal = document.getElementById("leadModal");
    if (!modal) return;
    modal.classList.add("open");
    modal.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden";
    trackingData.formOpenedTime = new Date().toISOString();
    var name = document.getElementById("fullName");
    if (name) name.focus();
  }

  function closeModal() {
    var modal = document.getElementById("leadModal");
    if (!modal) return;
    modal.classList.remove("open");
    modal.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
  }

  /* ==========================================================
     CLINIC PAGE
     ========================================================== */

  function initLanding() {
    collectTracking();

    document.querySelectorAll(".js-open-form").forEach(function (btn) {
      btn.addEventListener("click", openModal);
    });

    // Concern cards pre-select the dropdown before opening the modal.
    document.querySelectorAll("[data-open-concern]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var concern = document.getElementById("concern");
        if (concern) concern.value = btn.dataset.openConcern || "";
        openModal();
      });
    });

    var modal = document.getElementById("leadModal");
    var closeBtn = document.getElementById("closeModal");
    if (closeBtn) closeBtn.addEventListener("click", closeModal);
    if (modal) {
      modal.addEventListener("click", function (e) {
        if (e.target === modal) closeModal();
      });
    }
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") closeModal();
    });

    document.querySelectorAll(".video-wrap").forEach(function (wrap) {
      var video = wrap.querySelector("video");
      var btn = wrap.querySelector(".mute-btn");
      if (!video || !btn) return;
      btn.addEventListener("click", function () {
        document.querySelectorAll(".video-wrap video").forEach(function (other) {
          if (other !== video) {
            other.muted = true;
            var otherBtn = other.parentElement.querySelector(".mute-btn");
            if (otherBtn) otherBtn.textContent = "🔇";
          }
        });
        video.muted = !video.muted;
        btn.textContent = video.muted ? "🔇" : "🔊";
      });
    });

    var phoneInput = document.getElementById("phone");
    if (phoneInput) {
      phoneInput.setAttribute("maxlength", "10");
      phoneInput.addEventListener("input", function () {
        this.value = this.value.replace(/[^0-9]/g, "").slice(0, 10);
      });
    }

    var form = document.getElementById("leadForm");
    if (form) form.addEventListener("submit", handleSubmit);
  }

  function handleSubmit(e) {
    e.preventDefault();

    var form = e.currentTarget;
    var errorEl = document.getElementById("formError");
    var fullName = document.getElementById("fullName").value.trim();
    var phoneRaw = document.getElementById("phone").value.replace(/\D/g, "");
    var email = document.getElementById("email").value.trim();
    var concernEl = document.getElementById("concern");
    var concern = concernEl ? concernEl.value : "";
    var consent = document.getElementById("consent").checked;

    var wrapper = document.querySelector("[data-consultation]");
    var consultation =
      YUVRIT.consultation || (wrapper && wrapper.dataset.consultation) || "";

    if (fullName.length < 2) {
      errorEl.textContent = "Please enter your full name.";
      return;
    }
    if (!/^[0-9]{10}$/.test(phoneRaw)) {
      errorEl.textContent = "Please enter a valid 10-digit phone number.";
      return;
    }
    if (concernEl && !concern) {
      errorEl.textContent = "Please select a health concern.";
      return;
    }
    if (!consultation) {
      errorEl.textContent = "Please select a consultation medium.";
      return;
    }
    if (!consent) {
      errorEl.textContent = "Please agree to be contacted by Yuvrit.";
      return;
    }
    if (email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      errorEl.textContent = "Please enter a valid email, or leave it blank.";
      return;
    }

    errorEl.textContent = "";

    var branch = BRANCH || (CONSULTATIONS[consultation] || {}).branch || "";
    var concernLabel = CONCERN_LABELS[concern] || concern;
    var helpCategory = CONCERN_TO_BIGIN[concern] || "Other concerns";

    var lead = {
      name: fullName,
      phone: phoneRaw,
      email: email,
      helpCategory: helpCategory,
      concern: concern,
      concernLabel: concernLabel,
      centre: branch,
      consultation: consultation,
      centreName: CENTRE_NAME,
      formName: FORM_NAME,
      campaign: CAMPAIGN,
      consent: true,
    };

    var submitBtn = form.querySelector('button[type="submit"]');
    if (submitBtn) {
      submitBtn.textContent = "Sending…";
      submitBtn.disabled = true;
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "lead_form_submission",
      event_category: "lead",
      event_label: FORM_NAME,
      form_name: FORM_NAME,
      user_name: fullName,
      user_phone: phoneRaw,
      health_concern: concernLabel,
      centre: branch,
      traffic_source: trackingData.trafficSource,
      device_type: trackingData.deviceType,
      country: trackingData.country,
      value: 1,
      currency: "INR",
    });

    try {
      localStorage.setItem("yuvrit_lead_submitted", "true");
      sessionStorage.setItem("yuvritLead", JSON.stringify(lead));
    } catch (err) {
      /* private mode */
    }

    sendToBigin(lead, concernLabel);
    sendToSheet(lead);

    var redirectUrl =
      THANK_YOU_URL +
      "?consultation=" + encodeURIComponent(consultation) +
      "&name=" + encodeURIComponent(fullName) +
      "&phone=" + encodeURIComponent(phoneRaw) +
      "&category=" + encodeURIComponent(concernLabel);

    setTimeout(function () {
      window.location.href = redirectUrl;
    }, REDIRECT_DELAY_MS);
  }

  /* ==========================================================
     SENDING
     ========================================================== */

  // webNote is what lands in Bigin's Web_Notes: the visitor's exact concern
  // wording (the picklist mapping can flatten it) plus the preferred date once
  // the thank-you page collects one.
  function buildWebNote(concernLabel, preferredDate) {
    var parts = [];
    if (concernLabel) parts.push(concernLabel);
    if (preferredDate) parts.push("Preferred date: " + preferredDate);
    return parts.join(" | ");
  }

  // The thank-you page never runs collectTracking(), so it has no attribution
  // data of its own. The clinic page stashes the exact payload it sent, and the
  // preference form re-sends that same object with a date added — otherwise the
  // upsert would overwrite Website, City and Lead Source with blanks.
  function stashPayload(payload) {
    try {
      sessionStorage.setItem("yuvritBiginPayload", JSON.stringify(payload));
    } catch (err) {
      /* private mode */
    }
  }

  function readStashedPayload() {
    try {
      return JSON.parse(sessionStorage.getItem("yuvritBiginPayload") || "null");
    } catch (err) {
      return null;
    }
  }

  function postToBigin(payload) {
    return fetch(BIGIN_ENDPOINT, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
      keepalive: true,
    }).catch(function (err) {
      console.error("Bigin submission:", err);
    });
  }

  function sendToBigin(lead, concernLabel, preferredDate) {
    var payload = {
      formName: lead.formName || FORM_NAME,
      name: lead.name || "Website Lead",
      phone: lead.phone || "",
      email: lead.email || "",
      helpCategory: lead.helpCategory || "",
      otherConcerns: buildWebNote(concernLabel, preferredDate),
      centre: lead.centre || "",
      preferredDate: preferredDate || "",
      pageUrl: trackingData.pageUrl || lead.pageUrl || "",
      referrer: trackingData.referrer || "",
      city: trackingData.city || "",
      trafficSource: trackingData.trafficSource || "",
      gaClientId: trackingData.gaClientId || "",
      gclid: trackingData.gclid || "",
      fbclid: trackingData.fbclid || "",
      utmSource: trackingData.utmSource || "",
      utmMedium: trackingData.utmMedium || "",
      campaignName: trackingData.utmCampaign || "",
      adSetName: trackingData.utmContent || "",
    };

    stashPayload(payload);
    return postToBigin(payload);
  }

  function sendToSheet(lead, preferredDate) {
    if (!SHEET_ENDPOINT) return;
    var full = Object.assign({}, lead, trackingData, {
      preferredDate: preferredDate || "",
      timestamp: new Date().toISOString(),
    });
    fetch(SHEET_ENDPOINT, {
      method: "POST",
      body: JSON.stringify(full),
      keepalive: true,
    }).catch(function (err) {
      console.error("Google Sheet submission:", err);
    });
  }

  /* ==========================================================
     THANK-YOU PAGE
     ========================================================== */

  function formatPhone(digits) {
    return "+91 " + digits.slice(0, 5) + " " + digits.slice(5);
  }

  function isPriorityHoursIST() {
    var parts = new Intl.DateTimeFormat("en-GB", {
      timeZone: "Asia/Kolkata",
      hour: "2-digit",
      minute: "2-digit",
      hourCycle: "h23",
    }).formatToParts(new Date());
    var hour = Number(parts.find(function (p) { return p.type === "hour"; }).value);
    var minute = Number(parts.find(function (p) { return p.type === "minute"; }).value);
    var mins = hour * 60 + minute;
    return mins >= 9 * 60 + 30 && mins < 18 * 60;
  }

  function renderCallLinks(contacts, container) {
    container.innerHTML = "";
    contacts.forEach(function (item) {
      var p = document.createElement("p");
      p.textContent = item.label + ": " + formatPhone(item.phone);
      var a = document.createElement("a");
      a.className = "call-btn";
      a.href = "tel:+91" + item.phone;
      a.textContent = "Call " + item.label + " · " + formatPhone(item.phone);
      container.appendChild(p);
      container.appendChild(a);
    });
  }

  function getConsultationKey() {
    var key = getUrlParam("consultation") || getUrlParam("centre");
    if (!key) {
      try {
        var saved = JSON.parse(sessionStorage.getItem("yuvritLead") || "{}");
        key = saved.consultation || saved.centre || "";
      } catch (err) {
        key = "";
      }
    }
    return key;
  }

  function initThankYou() {
    var consultationKey = getConsultationKey();
    var selected = CONSULTATIONS[consultationKey];

    var suffix = document.getElementById("centreSuffix");
    if (suffix && selected && selected.phone) {
      suffix.textContent = " for the " + selected.label + " clinic";
    }

    var inPerson = ["indiranagar", "hsr", "aecs"]
      .map(function (key) {
        return { key: key, label: CONSULTATIONS[key].label, phone: CONSULTATIONS[key].phone };
      })
      .filter(function (item) { return item.phone; });

    // Online consultations have no clinic line, so show every branch instead.
    var contacts =
      consultationKey === "online" || !selected || !selected.phone
        ? inPerson
        : [{ label: selected.label, phone: selected.phone }];

    var priority = document.getElementById("priorityBlock");
    var afterHours = document.getElementById("afterHoursBlock");
    var contactBox = document.getElementById("centreContacts");
    if (!priority || !afterHours) return;

    if (isPriorityHoursIST()) {
      priority.hidden = false;
      afterHours.hidden = true;
      if (contactBox) renderCallLinks(contacts, contactBox);
    } else {
      priority.hidden = true;
      afterHours.hidden = false;
      document.getElementById("fromNumber").textContent =
        selected && selected.phone ? formatPhone(selected.phone) : "a Yuvrit number";
    }
  }

  /* ==========================================================
     CONSULTATION PREFERENCE FORM
     ========================================================== */

  function istYmd(date) {
    return new Intl.DateTimeFormat("en-CA", {
      timeZone: "Asia/Kolkata",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    }).format(date || new Date());
  }

  function addDaysToYmd(ymd, days) {
    var parts = ymd.split("-").map(Number);
    var next = new Date(Date.UTC(parts[0], parts[1] - 1, parts[2] + days));
    return (
      next.getUTCFullYear() +
      "-" + String(next.getUTCMonth() + 1).padStart(2, "0") +
      "-" + String(next.getUTCDate()).padStart(2, "0")
    );
  }

  function formatDateLabel(ymd, isToday, urgency) {
    var parts = ymd.split("-").map(Number);
    var date = new Date(parts[0], parts[1] - 1, parts[2]);
    var weekday = date.toLocaleDateString("en-IN", { weekday: "short" });
    var rest = date.toLocaleDateString("en-IN", { day: "numeric", month: "short" });
    var label = isToday ? "Today · " + weekday + ", " + rest : weekday + ", " + rest;
    if (urgency) label += " · Slots filling up fast";
    return label;
  }

  function initPreferenceForm() {
    var form = document.getElementById("preferenceForm");
    var select = document.getElementById("prefDate");
    var otherWrap = document.getElementById("otherDateWrap");
    var otherInput = document.getElementById("prefDateOther");
    if (!form || !select || !otherWrap || !otherInput) return;

    var today = istYmd();
    for (var i = 0; i < 6; i += 1) {
      var ymd = addDaysToYmd(today, i);
      var option = document.createElement("option");
      option.value = ymd;
      option.textContent = formatDateLabel(ymd, i === 0, i < 3);
      select.appendChild(option);
    }
    var other = document.createElement("option");
    other.value = "other";
    other.textContent = "Other";
    select.appendChild(other);

    otherInput.min = today;

    select.addEventListener("change", function () {
      var isOther = select.value === "other";
      otherWrap.hidden = !isOther;
      if (isOther) otherInput.focus();
    });

    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var errorEl = document.getElementById("prefError");
      var dateValue = select.value;
      if (dateValue === "other") dateValue = otherInput.value;

      if (select.value === "other" && !otherInput.value) {
        errorEl.textContent =
          "Please pick a date from the calendar, or choose one of the listed dates.";
        return;
      }

      errorEl.textContent = "";

      var lead = {};
      try {
        lead = JSON.parse(sessionStorage.getItem("yuvritLead") || "{}");
        lead.preferredDate = dateValue || "";
        sessionStorage.setItem("yuvritLead", JSON.stringify(lead));
      } catch (err) {
        /* private mode */
      }

      var btn = form.querySelector('button[type="submit"]');
      if (btn) {
        btn.disabled = true;
        btn.textContent = "Saving…";
      }

      // Re-send the payload the clinic page already built, with the date added.
      // The Bigin API upserts on Mobile_Number, so this updates the same contact
      // rather than creating a second one. With no stashed payload (direct hit
      // on this URL, or storage blocked) there is nothing to match on, so the
      // choice is kept locally only.
      var stashed = readStashedPayload();
      var done = Promise.resolve();

      if (stashed && stashed.phone) {
        stashed.preferredDate = dateValue || "";
        stashed.otherConcerns = buildWebNote(lead.concernLabel || "", dateValue);
        stashPayload(stashed);
        done = postToBigin(stashed);
        sendToSheet(lead, dateValue);
      }

      done.then(function () {
        form.hidden = true;
        var savedNote = document.getElementById("prefSaved");
        if (savedNote) savedNote.hidden = false;
      });
    });
  }

  function boot() {
    if (document.getElementById("leadForm")) initLanding();
    if (document.getElementById("priorityBlock")) initThankYou();
    if (document.getElementById("preferenceForm")) initPreferenceForm();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
